import React from 'react'

import NavBar from '../landing/navbar'
import Footer from '../landing/footer'
import PrivacyContent from './PrivacyContent'
import './faq.scss'

const Privacy = () => (
  <div className='faq-page'>
    <NavBar />
    <main className='container col-xxl-8 py-5'>
      <PrivacyContent />
    </main>
    <Footer />
  </div>
)

export default Privacy
